import { FETCH_CAR_READINGS } from '../types';

const initialState = {
  readings: [],
};

const readings = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CAR_READINGS:
      return { ...state, readings: action.readings };
    default:
      return state;
  }
};

export default readings;
